import { Namespace, TFuncKey } from 'react-i18next';

export const HOSTFULLY_ASSIST_PRICE_PER_PROPERTY = 9;

export const HOSTFULLY_ASSIST_CURRENCY = 'USD';

export const HOSTFULLY_ASSIST_TERMS_URL =
  'https://www.hostbuddy.ai/termsof-service';

export const HOSTFULLY_ASSIST_PRIVACY_URL =
  'https://www.hostbuddy.ai/privacy-policy';

type IncludedFeature = {
  labelKey: TFuncKey<Namespace<'en'>>;
  testId: string;
};

type IncludedRow = {
  column1: IncludedFeature;
  column2: IncludedFeature;
};

export const INCLUDED_ROWS = [
  {
    column1: {
      testId: 'assist-details-included-1',
      labelKey: 'pageHostfullyAssist.details.included.aiPoweredMessaging',
    },
    column2: {
      testId: 'assist-details-included-2',
      labelKey: 'pageHostfullyAssist.details.included.actionItemNotifications',
    },
  },
  {
    column1: {
      testId: 'assist-details-included-3',
      labelKey: 'pageHostfullyAssist.details.included.smartInbox',
    },
    column2: {
      testId: 'assist-details-included-4',
      labelKey: 'pageHostfullyAssist.details.included.pastConversationLearning',
    },
  },
  {
    column1: {
      testId: 'assist-details-included-5',
      labelKey: 'pageHostfullyAssist.details.included.conversationHistory',
    },
    column2: {
      testId: 'assist-details-included-6',
      labelKey: 'pageHostfullyAssist.details.included.testingSandbox',
    },
  },
  {
    column1: {
      testId: 'assist-details-included-7',
      labelKey: 'pageHostfullyAssist.details.included.customToneAndDelay',
    },
    column2: {
      testId: 'assist-details-included-8',
      labelKey: 'pageHostfullyAssist.details.included.globalLanguageSupport',
    },
  },
  {
    column1: {
      testId: 'assist-details-included-9',
      labelKey:
        'pageHostfullyAssist.details.included.knowledgeBaseCustomization',
    },
    column2: {
      testId: 'assist-details-included-10',
      labelKey: 'pageHostfullyAssist.details.included.teamCollaboration',
    },
  },
] as const satisfies IncludedRow[];

export type IncludedRowContent = (typeof INCLUDED_ROWS)[number];
